import Header from './components/Header';
import Invitation from './components/Invitation';
import Countdown from './components/Countdown';
import Venue from './components/Venue';
import Schedule from './components/Schedule';
import DressCode from './components/DressCode';
import GuestForm from './components/Allergies';
import Gallery from './components/Gallery';
import Organizer from './components/Organizer';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="app__main">
        <div className="app__divider"></div>
        <Invitation/>
        <div className="app__divider"></div>
        <Countdown targetDate="2026-06-21T16:00:00"/>
        <div className="app__divider"></div>
        <Venue/>
        <div className="app__divider"></div>
        <Schedule/>
        <div className="app__divider"></div>
        <DressCode/>
        <div className="app__divider"></div>
        <GuestForm/>
        <div className="app__divider"></div>
        <Gallery/>
        <div className="app__divider"></div>
        <Organizer/>
        <div className="app__divider"></div>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
